import { AsyncPipe } from '@angular/common';
import {
  Component,
  CUSTOM_ELEMENTS_SCHEMA,
  inject,
  OnDestroy,
  OnInit,
  signal,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BluApiService } from '@app/services/blu-api.service';
import { ChannelsService } from '@app/services/channels.service';
import { SharedService } from '@app/services/shared.service';
import { UserService } from '@app/services/user.service';
import { SharedModalComponent } from '@shared/components/modal/modal.component';
import { QRCodeModule } from 'angularx-qrcode';
import { Subject } from 'rxjs';

@Component({
  selector: 'blu-activate-channel',
  templateUrl: './activate-channel.component.html',
  styleUrls: ['./activate-channel.component.scss'],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  standalone: true,
  imports: [QRCodeModule, AsyncPipe, SharedModalComponent],
})
export class ActivateChannelComponent implements OnInit, OnDestroy {
  qr$ = signal<Subject<string> | null>(null);

  public route = inject(ActivatedRoute);
  private router = inject(Router);
  public sharedService = inject(SharedService);
  public bluApi = inject(BluApiService);
  private channelsService = inject(ChannelsService);
  private userService = inject(UserService);

  ngOnInit(): void {
    const id = this.route.snapshot.paramMap.get('id');
    if (!id) return;
    const url = this.router.url;

    let qr$;
    if (this.userService.isBetaTester() && url.includes('warmup')) {
      qr$ = this.bluApi.initializeWarmupQR(id);
    } else qr$ = this.bluApi.initializeChannelQR(id);

    if (!qr$) return;
    this.qr$.set(qr$);
    qr$.subscribe({
      error: () => this.sharedService.closeModal(this.route),
      complete: () => {
        this.sharedService.closeModal(this.route);
        this.channelsService.setChannelToConnected(id);
      },
    });
  }

  ngOnDestroy(): void {
    this.bluApi.closeQRConnection();
  }
}
